document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".audio-player").forEach((wrapper) => {
    const btn = wrapper.querySelector(".play-btn");
    const waveformEl = wrapper.querySelector(".waveform");
    const audioUrl = btn.getAttribute("data-audio");

    if (!audioUrl) return;

    // create waveform immediately (Cymatics style)
    wrapper.wavesurfer = WaveSurfer.create({
      container: waveformEl,
      waveColor: "#ddd",
      progressColor: "#7a1effff",
      height: 30,
      barWidth: 2,
      responsive: true,
      backend: "MediaElement"
    });

    wrapper.wavesurfer.load(audioUrl);

    wrapper.wavesurfer.on("finish", () => {
      btn.textContent = "▶";
    });
  });

  // click control (same behavior as before)
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".play-btn");
    if (!btn) return;

    const wrapper = btn.closest(".audio-player");
    const ws = wrapper.wavesurfer;

    if (!ws) return;

    if (ws.isPlaying()) {
      ws.pause();
      btn.textContent = "▶";
    } else {
      ws.play();
      btn.textContent = "❚❚";
    }
  });
});